import { Navigate, useSearchParams } from 'react-router-dom';
import { GENERATION_PATH } from './generationPrefill';
import { sharePrefill } from './sharePrefill';

/**
 * `/share`, where the installed app receives a share from another app (the
 * manifest's `share_target`). It shows nothing of its own: the share becomes
 * a brief prefill and the user lands on `/generation` with it, exactly as from
 * a news card. Replace, so Back does not return to this hop.
 *
 * Signed out, the route guard sends the user to sign in with `/share?…` as the
 * next path, so the share survives the detour.
 */
export function SharePage() {
  const [params] = useSearchParams();
  const prefill = sharePrefill(params);
  return <Navigate to={GENERATION_PATH} replace state={prefill ?? undefined} />;
}
